import React, { useLayoutEffect, useRef, useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Stack,
    Fade,
    TextField,
    Collapse,
} from '@mui/material';
import MacPhoto from '../../assets/images/Screenshot.png';
import PaperPlane from '../../assets/images/Block1papers.png';

const Block1 = () => {
    // Toggle between "Join the waitlist" and email input form
    const [showInput] = React.useState(false);
    const [circleH, setCircleH] = useState(0);
    const [circleTop, setCircleTop] = useState(0);
    const rootRef = useRef(null);
    const btnRef  = useRef(null);

    useLayoutEffect(() => {
        const update = () => {
            if (!rootRef.current || !btnRef.current) return;

            // The distance of the component's head from the document (not from the viewport)
            const containerDocTop = rootRef.current.getBoundingClientRect().top + window.scrollY;

            // Button rectangle and its center (relative to the document)
            const btnRect      = btnRef.current.getBoundingClientRect();
            const btnCenterDoc = btnRect.top + window.scrollY + btnRect.height / 2;

            // 20-px above the top of the page
            setCircleTop(-20 - containerDocTop);

            // Ends exactly in the center of the button
            setCircleH(btnCenterDoc + 20);
        };

        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    return (
        <Box
            ref={rootRef}
            sx={{
                textAlign: 'center',
                p: 4,
                my: 15,
                position: 'relative',
            }}
        >
            {/* Responsive SVG Positioning */}
            <Box
                component="img"
                src={PaperPlane}
                alt="Paper Plane Illustration"
                draggable="false"
                sx={{
                    position: 'absolute',
                    top: {
                        xs: '-120px',
                        sm: '-100px',
                    },
                    left: {
                        xs: 'auto',
                        sm: 'auto',
                    },
                    right: {
                        xs: '0px',
                        sm: '20px',
                    },
                    width: {
                        xs: '50vw',
                        sm: '28vw',
                    },
                    maxWidth: '600px',
                    zIndex: -1,
                }}
            />

            {/* Half Circle for Desktop */}
            <Box
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    position: 'absolute',
                    top: '30%',
                    left: '-10px',
                    transform: 'translateY(-50%)',
                    width: '50vh',
                    height: '100vh',
                    background: 'linear-gradient(to right, #F7FCFF, #ffffff)',
                    borderRadius: '0 1000px 1000px 0',
                    boxShadow: '0 0 12px rgba(0, 0, 0, 0.1)',
                    zIndex: -2,
                }}
            />

            {/* Half Circle for Mobile */}
            <Box
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    position: 'absolute',
                    top: circleTop+20,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '100vw',
                    height: circleH,
                    background: 'linear-gradient(to bottom, #FFFF, #F7FCFF )',
                    borderRadius: '0 0 500px 500px',
                    boxShadow: '0 0 12px rgba(0,0,0,0.1)',
                    zIndex: -2,
                    pointerEvents: 'none',
                }}
            />


            <Stack spacing={4} alignItems="center">
                {/* Title */}
                <Typography
                    sx={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 600,
                        color: '#383838',
                        fontSize: {
                            xs: '2rem',
                            sm: '2.6rem',
                        },
                    }}
                >
                    Your Next Trip, Just Better
                    <Typography
                        variant="h6"
                        component="p"
                        sx={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 400,
                            fontSize: {
                                xs: '1.1rem',
                                sm: '1.1rem',
                            },
                        }}
                    >
                        We develop a proprietary AI agent for the travel industry.
                    </Typography>
                </Typography>

                {/* Join the Beta button */}
                <Fade in={!showInput} timeout={300}>
                    <Box>
                 <Button
    ref={btnRef}
    variant="contained"
    sx={{
        background: 'linear-gradient(to right, #DC5454, #F36969)',
        textTransform: 'none',
        borderRadius: '100px',
        boxShadow: 'none',
        fontSize: '1.1rem',
        fontWeight: 500,
        padding: '12px 26px',
        '&:hover': {
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
        mb: {
            xs: 0.5,
            sm: 3,
        },
    }}
    // onClick={() => window.location.href = 'https://travel-beta.com/'} // בוטל
>
    Beta access is not available at this time
</Button>

                    </Box>
                </Fade>

                {/* Image Below */}
                <Box
                    component="img"
                    src={MacPhoto}
                    alt="Block1 Illustration"
                    draggable="false"
                    sx={{
                        width: {
                            xs: '100%',
                            sm: '60%',
                        },
                        borderRadius: '20px',
                        // border: '1px solid red',
                        boxShadow: '0 0 12px rgba(0, 0, 0, 0.08)'
                    }}
                />
            </Stack>
        </Box>
    );
};

export default Block1;
